import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostLaureatLapp(action) {
	try {
		const result = yield fromApi.laureatLappPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_LAUREATLAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetLaureatLapps(action) {
	try {
		const result = yield fromApi.laureatLappsGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_LAUREATLAPPS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetLaureatLapp(action) {
	try {
		const result = yield fromApi.laureatLappGet(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_LAUREATLAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutLaureatLapp(action) {
	try {
		const result = yield fromApi.laureatLappPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_LAUREATLAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelLaureatLapp(action) {
	try {
		const result = yield fromApi.laureatLappDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_LAUREATLAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* laureatslapp() {
	yield takeLatest('POST_LAUREATLAPP_SAGAS', watchPostLaureatLapp);
	yield takeLatest('GET_LAUREATLAPPS_SAGAS', watchGetLaureatLapps);
	yield takeLatest('GET_LAUREATLAPP_SAGAS', watchGetLaureatLapp);
	yield takeLatest('PUT_LAUREATLAPP_SAGAS', watchPutLaureatLapp);
	yield takeLatest('DEL_LAUREATLAPP_SAGAS', watchDelLaureatLapp);
}

export default function* rootSaga() {
	yield all([laureatslapp()]);
}
